<div class="content-container">
  @if (promotion_id && promotion_id > 0) {
    <div class="promotion-info">
      <h3>Promotion: {{promotion_name}}</h3>
    </div>
  }

  <dx-load-panel
    [visible]="loadingVisible"
    message="Loading negotiation data..."
    [showIndicator]="true"
    [showPane]="true">
  </dx-load-panel>

  <dx-data-grid
    [dataSource]="dataSource"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [columnAutoWidth]="true"
    [showBorders]="true"
    [showRowLines]="true"
    [rowAlternationEnabled]="true"
    keyExpr="promo_group_id"
    (onEditingStart)="onEditingStart($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowValidating)="onRowValidating($event)"
    [height]="'80vh'">
    
    <!-- Editing Configuration -->
    <dxo-editing 
      mode="batch" 
      [allowUpdating]="true"
      [useIcons]="true">
    </dxo-editing>
    
    <!-- Scrolling Configuration -->
     <dxo-scrolling mode="virtual"></dxo-scrolling>
    
    <!-- Search Panel -->
    <dxo-search-panel 
      [visible]="true"
      [width]="240"
      placeholder="Search negotiations...">
    </dxo-search-panel>
        
    <!-- Header Filter -->
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    
    <!-- Column Chooser -->
    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
        
    <!-- Columns - Based on the planning-data API response structure -->
    <dxi-column 
      dataField="promo_group_id" 
      caption="Promo Group ID" 
      [width]="120"
      [allowEditing]="false">
    </dxi-column>
    
    <dxi-column 
      dataField="promotion_group_name" 
      caption="Promotion Group Name"
      [width]="200"
      [allowEditing]="false">
    </dxi-column>
    
    <dxi-column 
      dataField="buying_group_id" 
      caption="Buying Group ID"
      [width]="120"
      [visible]="false"
      [allowEditing]="false">
    </dxi-column>
    
    <dxi-column 
      dataField="buying_group_name" 
      caption="Buying Group Name"
      [width]="200"
      [allowEditing]="false">
    </dxi-column>
    
    <dxi-column 
      dataField="sell_price" 
      caption="Sell Price" 
      dataType="number"
      format="currency"
      [width]="120">
      <dxi-validation-rule type="range" [min]="0" message="Sell price must be positive"></dxi-validation-rule>
    </dxi-column>
    
    <dxi-column 
      dataField="allowance" 
      caption="Allowance" 
      dataType="number"
      format="currency"
      [width]="120">
      <dxi-validation-rule type="range" [min]="0" message="Allowance must be positive"></dxi-validation-rule>
    </dxi-column>

    @for(column of rebateNames$ | async; track column) {
      <dxi-column
        [dataField]="column.rebate_name"
        [format]="currencyFormat"
        [dataType]="'number'"
        [width]="120"
        [allowEditing]="true">
      </dxi-column>
    }
    
    <dxi-column 
      dataField="slot_type_name" 
      caption="Slot Type"
      [width]="120"
      [allowEditing]="false">
    </dxi-column>
    
    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
    <div *dxTemplate="let item of 'detail'">
        <app-promotion-group-items [key]="item.data.promo_group_id" [negotiation]="true"></app-promotion-group-items>
    </div>

  </dx-data-grid>
</div>
